module.exports = __webpack_public_path__ + "img/tiket.e2bd643f.png";